import './App.css';
import Header from "./components/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from "react-bootstrap/Container";
import {Routes, Route} from "react-router";
import MainPage from "./components/MainPage";
import DataPage from "./components/Data";
import React from "react";
import Credits from "./components/Credits";
import Footer from "./components/Footer";
import Publications from "./components/Publications";


function App() {
    return (

        <Container className={"py-4 px-3 mx-auto"}>
            <Header/>

            <Routes>
                <Route exact path='/' element={<MainPage/>}/>
                <Route exact path='/getdata' element={<DataPage/>}/>
                <Route exact path='/credits' element={<Credits/>}/>
                <Route  exact path='/publications' element={<Publications/>}/>
            </Routes>
            <Footer/>
        </Container>

    );
}

export default App;
